import { useRef, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { Delete, Edit, MoreVert, Pause, PlayArrow } from "@mui/icons-material";

// ----------------------------------------------------------------------

export default function MoreMenu({
  setOpenDeleteDialog,
  setOpenEditDialog,
  setRow,
  setOpenSuspendDialog,
  setOpenUnsuspendDialog,
  is_suspended = false,
}) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Tooltip title="Delete" placement="top">
        <IconButton
          onClick={() => {
            setOpenDeleteDialog(true);
            setRow();
          }}
        >
          <Delete />
        </IconButton>
      </Tooltip>

      <Tooltip title="Edit" placement="top">
        <IconButton
          onClick={() => {
            setOpenEditDialog(true);
            setRow();
          }}
        >
          <Edit />
        </IconButton>
      </Tooltip>

      {!is_suspended && setOpenSuspendDialog && (
        <Tooltip title="Suspend" placement="top">
          <IconButton
            onClick={() => {
              setOpenSuspendDialog(true);
              setRow();
            }}
          >
            <Pause />
          </IconButton>
        </Tooltip>
      )}

      {is_suspended && setOpenUnsuspendDialog && (
        <Tooltip title="Unsuspend" placement="top">
          <IconButton
            onClick={() => {
              setOpenUnsuspendDialog(true);
              setRow();
            }}
          >
            <PlayArrow />
          </IconButton>
        </Tooltip>
      )}
    </>
  );

  // return (
  //   <>
  //     <IconButton ref={ref} onClick={() => setIsOpen(true)}>
  //       <MoreVert />
  //     </IconButton>

  //     <Menu
  //       open={isOpen}
  //       anchorEl={ref.current}
  //       onClose={() => setIsOpen(false)}
  //       PaperProps={{
  //         sx: { width: 200, maxWidth: "100%" },
  //       }}
  //       anchorOrigin={{ vertical: "top", horizontal: "right" }}
  //       transformOrigin={{ vertical: "top", horizontal: "right" }}
  //     >
  //       <MenuItem
  //         onClick={() => {
  //           setOpenEditDialog(true);
  //           setRow();
  //         }}
  //         sx={{ color: "text.secondary" }}
  //       >
  //         <ListItemIcon>
  //           <Edit />
  //         </ListItemIcon>
  //         <ListItemText
  //           primary="Edit"
  //           primaryTypographyProps={{ variant: "body2" }}
  //         />
  //       </MenuItem>
  //       <MenuItem
  //         sx={{ color: "text.secondary" }}
  //         onClick={() => {
  //           setOpenDeleteDialog(true);
  //           setRow();
  //         }}
  //       >
  //         <ListItemIcon>
  //           <Delete />
  //         </ListItemIcon>
  //         <ListItemText
  //           primary="Delete"
  //           primaryTypographyProps={{ variant: "body2" }}
  //         />
  //       </MenuItem>
  //     </Menu>
  //   </>
  // );
}
